var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    stroke: "rgba(0,0,0,0.7)",
    strokeWidth: 2,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 7.5H11.75C10.7835 7.5 10 8.2835 10 9.25V19.75C10 20.7165 10.7835 21.5 11.75 21.5H17.875M21.375 7.5H22.25C23.2165 7.5 24 8.2835 24 9.25V10.125M24 18.875V19.75C24 20.7165 23.2165 21.5 22.25 21.5H21.375M24 13.625V15.375M17 5.75V23.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareSlider);
export default __webpack_public_path__ + "static/media/compareSlider.31c8b48a60ccf68fb1c71cba39306719.svg";
export { ForwardRef as ReactComponent };